
(function () {
  function updateSpecsColumnWidths() {
    document.querySelectorAll('.product-specs-table').forEach((table) => {
      const labels = Array.from(table.querySelectorAll('th'))
        .filter((label) => label.getClientRects().length > 0);

      if (!labels.length) return;

      const isMobile = window.innerWidth <= 749;

      const maxWidth = table.clientWidth * (
        isMobile ? 0.60 : 0.62
      );

      const padding = isMobile ? 16 : 24;

      let widestLabel = 0;

      labels.forEach((label) => {
        const measure = document.createElement('span');
        const styles = window.getComputedStyle(label);

        measure.textContent = label.textContent.trim();
        measure.style.font = styles.font;
        measure.style.fontWeight = styles.fontWeight;
        measure.style.whiteSpace = 'nowrap';
        measure.style.position = 'absolute';
        measure.style.visibility = 'hidden';

        document.body.appendChild(measure);

        widestLabel = Math.max(
          widestLabel,
          measure.getBoundingClientRect().width
        );

        measure.remove();
      });

      const calculatedWidth = Math.min(
        Math.ceil(widestLabel + padding + 4),
        maxWidth
      );

      table.style.setProperty(
        '--specs-label-width',
        calculatedWidth + 'px'
      );
    });
  }

  function updateSpecsVariant(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-product-specs]').forEach((specs) => {
      const template = Array.from(
        specs.querySelectorAll('template[data-specs-variant-id]')
      ).find((item) => item.dataset.specsVariantId === String(variantId));

      const tbody = specs.querySelector('[data-product-specs-body]');

      if (!template || !tbody) return;

      tbody.replaceChildren(template.content.cloneNode(true));

      const table = specs.querySelector('.product-specs-table');
      const heading = specs.querySelector('.product-specs__heading');
      const hasRows = tbody.querySelector('tr') !== null;

      if (table) table.hidden = !hasRows;
      if (heading) heading.hidden = !hasRows;

      updateSpecsColumnWidths();
    });
  }

  document.addEventListener('shopify:product:select', function(event) {
    if (!event.promise || !event.target.matches('kit-variant-picker')) {
      return;
    }

    event.promise
      .then(function() {
        const variantElement = event.target.querySelector(
          '[data-kit-selected-variant]'
        );

        if (!variantElement) return;

        let variant;

        try {
          variant = JSON.parse(variantElement.textContent.trim());
        } catch (error) {
          console.error(
            'Technische Daten: Varianten-JSON ungültig.',
            error
          );
          return;
        }

        if (!variant || !variant.id) return;

        updateSpecsVariant(variant.id);
      })
      .catch(function(error) {
        if (error && error.name === 'AbortError') return;

        console.error(
          'Technische Daten: Variantenwechsel fehlgeschlagen.',
          error
        );
      });
  });

  function initializeSpecs() {
    document.querySelectorAll('[data-product-specs]').forEach((specs) => {
      const initialVariantId = specs.dataset.initialVariantId;
      updateSpecsVariant(initialVariantId);
    });

    updateSpecsColumnWidths();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeSpecs);
  } else {
    initializeSpecs();
  }

  document.addEventListener('shopify:section:load', initializeSpecs);

  window.addEventListener('resize', updateSpecsColumnWidths);
})();
